export default function Icon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="36"
      height="37"
      viewBox="0 0 36 37"
      fill="none"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.1993 1.37083C15.5922 0.667231 16.2887 0.315433 17.0198 0.17702C17.6674 0.0544372 18.3322 0.0544372 18.9797 0.17702C19.7108 0.315434 20.4073 0.66723 21.8002 1.37082L29.0058 5.0105L23.9747 8.73056C22.2325 7.71749 20.1873 7.13413 17.9998 7.13413C11.635 7.13413 6.47537 12.0726 6.47537 18.1646C6.47537 20.7096 7.37587 23.0533 8.88853 24.9197L5.13415 30.3718C4.24169 29.9023 3.68803 29.5572 3.24986 29.1073C2.70707 28.5499 2.29447 27.8792 2.04169 27.1435C1.75586 26.3115 1.75586 25.37 1.75586 23.487L1.75586 12.842C1.75586 10.9591 1.75586 10.0176 2.0417 9.18564C2.29447 8.44986 2.70708 7.77919 3.24986 7.22183C3.86362 6.59157 4.70397 6.1671 6.38466 5.31815L14.1993 1.37083ZM13.4638 28.3078L6.82189 31.2318L14.1993 34.9583L14.1993 34.9583C15.5922 35.6619 16.2887 36.0137 17.0198 36.1521C17.6674 36.2747 18.3321 36.2747 18.9797 36.1521C19.7108 36.0137 20.4073 35.6619 21.8002 34.9583L21.8002 34.9583L29.6149 31.0109L29.6149 31.0109L29.6149 31.0109C31.2956 30.162 32.1359 29.7375 32.7497 29.1073C33.2924 28.5499 33.705 27.8792 33.9578 27.1435C34.2437 26.3115 34.2437 25.37 34.2437 23.487L34.2437 12.842C34.2437 10.9591 34.2437 10.0176 33.9578 9.18564C33.705 8.44986 33.2924 7.7792 32.7497 7.22183C32.2919 6.75179 31.7081 6.3962 30.7437 5.89362L28.2006 13.0273C29.0458 14.5616 29.5242 16.3096 29.5242 18.1646C29.5242 24.2566 24.3645 29.1951 17.9998 29.1951C16.3893 29.1951 14.8559 28.8789 13.4638 28.3078Z"
        fill="url(#paint0_linear_1327_12171)"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M27.9502 4.9282L13.9464 13.9941C13.8298 14.0696 13.7319 14.174 13.6611 14.2984L5.15395 29.2415C4.69247 30.0521 5.55952 30.9791 6.31918 30.4873L20.3231 21.4214C20.4397 21.3459 20.5375 21.2416 20.6083 21.1171L29.1155 6.17406C29.577 5.36345 28.7099 4.43641 27.9502 4.9282ZM16.7258 19.4275C17.638 19.6719 18.5849 19.0959 18.8407 18.141C19.0966 17.1861 18.5645 16.2139 17.6523 15.9694C16.7402 15.725 15.7933 16.301 15.5374 17.2559C15.2815 18.2108 15.8136 19.183 16.7258 19.4275Z"
        fill="#FAFAFA"
      />
      <defs>
        <linearGradient
          id="paint0_linear_1327_12171"
          x1="1.76949"
          y1="18.2307"
          x2="34.172"
          y2="18.2307"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#28F2FF" />
          <stop offset="1" stopColor="#A596FF" />
        </linearGradient>
      </defs>
    </svg>
  );
}
